export const occupationList = [
    {
      code: 'PVT_SECTOR_SERVICE',
      name: 'Private Sector Service'
    },
    {
      code: 'PUBLIC_SECTOR',
      name: 'Public Sector'
    },
    {
      code: 'BUSINESS',
      name: 'Business'
    },
    {
      code: 'PROFESSIONAL',
      name: 'Professional'
    },
    {
      code: 'AGRICULTURIST',
      name: 'Agriculturist'
    },
    {
      code: 'RETIRED',
      name: 'Retired'
    },
    {
      code: 'HOUSEWIFE',
      name: 'Housewife'
    },
    {
      code: 'STUDENT',
      name: 'Student'
    },
    {
      code: 'FOREX_DEALER',
      name: 'Forex Dealer'
    },
    {
      code: 'GOVERNMENT_SERVICE',
      name: 'Government Service'
    },
    // {
    //   code: 'PUBLIC_SECTOR_GOVERNMENT_SERVICE',
    //   name: 'Public Sector / Government Service'
    // },
    // {
    //   code: 'OTHERS',
    //   name: 'Others'
    // },
]
